const sexo = [
  { valor: "M", etiqueta: "Masculino" },
  { valor: "F", etiqueta: "Femenino" },
  { valor: "X", etiqueta: "Otro" },
];

export default sexo;
